import React from "react";

const reasons = [
  {
    title: "Experience Since 2017",
    text: "We have been building digital solutions for businesses for years and have delivered projects for more than 300 clients.",
  },
  {
    title: "UAE-Based Development Team",
    text: "We understand the local market, customer expectations, and business requirements in the UAE.",
  },
  {
    title: "Complete Development Support",
    text: "From idea planning and design to development and post-launch support, we manage the complete process.",
  },
  {
    title: "Transparent Communication",
    text: "You stay updated throughout the project with regular discussions, prototypes, and progress reviews.",
  },
  {
    title: "Secure and Reliable Development",
    text: "We follow professional development practices to create stable and secure applications.",
  },
];

export default function Section8() {
  return (
    <div className="w-full Section8 py-[35px]">
      <div className="container-1280 section8-container w-full px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%]">
        <h2 className="text-[22px] md:text-[30px] font-bold leading-[28px] md:leading-[38px] text-center my-[0.67em] text-[#151515]">
          Why Choose Mean3 as Your Mobile App Development Company in UAE?
        </h2>

        <p className="w-full md:w-[75%] mx-auto text-center leading-[22px] text-[#535353] text-sm md:text-base font-open mb-8">
          There are many mobile app development companies in Dubai and
          across the UAE. Here is what makes Mean3 different:
        </p>

        <div className="boxes w-full flex justify-center gap-x-[2%] gap-y-[19px] flex-wrap">
          {reasons.map((item, index) => (
            <div
              key={item.title}
              className={`w-full xs:w-[45%] md:w-[30%] p-[5%] rounded-[6px] ${
                (index + 1) % 2 === 0 ? "bg-[#F5F5F5] text-[#535353]" : "bg-[#cd2122] text-white"
              }`}
            >
              <h3 className="text-[16px] md:text-[18px] font-bold leading-[24px] my-[0.4em] font-open">
                {item.title}
              </h3>
              <p className="text-xs md:text-sm leading-[20px] font-open">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
